import React, { Fragment } from 'react';

import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { localizable } from '../../../components/Localization';

export default localizable('NotifySeller')(
  ({ t, store: { message, handleMessageChange } }) => (
    <Fragment>
      <ul className="hint">
        <li>{t('This text will appear as an additional note')}</li>
      </ul>

      <div className="control">
        <TextField
          label={t('Message')}
          multiline
          name="ag"
          value={message}
          onChanged={handleMessageChange}
        />
      </div>
    </Fragment>
  )
);



// WEBPACK FOOTER //
// ./src/app/containers/SaleWizard/NotifySeller/Step1.jsx